// 格式化工具：金额、日期、状态色、PAN 掩码
//
// 通用四函数（formatMoney / formatDateTime / formatDate / formatPercent）已收敛至
// web/shared/formats/format.ts（单一真源；迁移前已逐函数 diff，merchant 原有三者行为一致），
// 此处 re-export 保持既有 `@/lib/format` import 路径不变。
//
// decimal 三函数（compareDecimal / isPositiveDecimal / sumDecimals）已下沉至
// web/shared/formats/decimal.ts（FE-E1a；下沉前与 customer 实现逐字 diff 一致，以本文件为底本搬运）。
//
// 注：admin 同层文件使用 `@shared/formats/format` 别名；merchant 的 lib 模块被
// node --experimental-strip-types 测试（如 financeEmptyAccount.test.ts）直接 import，
// 而 Node 不解析 tsconfig paths，故此处改用相对路径引用同一真源（仅引用写法不同）。
// 以下仅保留 shared 未覆盖的 merchant 专属展示/精度工具。

export {
  formatDate,
  formatDateTime,
  formatMoney,
  formatPercent,
} from '../../../shared/formats/format.ts';

export {
  compareDecimal,
  isPositiveDecimal,
  sumDecimals,
} from '../../../shared/formats/decimal.ts';

/** 状态 → badge 样式映射（通用） */
export type BadgeKind = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

const POSITIVE = new Set([
  'ACTIVE',
  'APPROVED',
  'COMPLETED',
  'PAID',
  'VERIFIED',
  'RESOLVED',
  'READY',
  'FILED',
  'OK',
  'LIVE',
  'PUBLISHED',
  'SENT',
  'MATCHED',
  'DONE',
  'REWRITTEN',
  'CLOSED',
]);
const NEGATIVE = new Set([
  'REJECTED',
  'FAILED',
  'FROZEN',
  'TERMINATED',
  'SUSPENDED',
  'OVERDUE',
  'EXPIRED',
  'DECLINE',
  'DEAD',
  'ERROR',
  'CRIT',
]);
const PENDING = new Set([
  'PENDING',
  'PENDING_OPEN',
  'PENDING_APPROVAL',
  'SUBMITTED',
  'UNDER_REVIEW',
  'PROCESSING',
  'APPLIED',
  'QUEUED',
  'GENERATING',
  'DRAFT',
  'FIRING',
  'SENDING',
  'OPEN',
  'INVESTIGATING',
  'WARN',
  'NEED_INFO',
]);

export function statusBadge(status: string): BadgeKind {
  if (POSITIVE.has(status)) return 'success';
  if (NEGATIVE.has(status)) return 'danger';
  if (PENDING.has(status)) return 'warning';
  return 'neutral';
}

/** 风险等级 / 严重度 → 徽章 */
export function severityBadge(level: string): BadgeKind {
  switch (level) {
    case 'critical':
    case 'high':
    case 'P0':
    case 'P1':
      return 'danger';
    case 'medium':
    case 'P2':
      return 'warning';
    case 'low':
    case 'P3':
      return 'info';
    default:
      return 'neutral';
  }
}

